export const menuItems = [
  {
    title: "Proyectos",
    subItems: [
      { label: "Universo ERI", path: "/historia" },
      { label: "Nuestros proyectos", path: "/proyectos" },
      { label: "Histórico de eventos", path: "/eventos" },
      { label: "Trading Card Game", path: "/tcg" },
    ],
  },
  {
    title: "Palos",
    subItems: [
      { label: "Conoce los palos", path: "palos" },
      { label: "Test: ¿En cuál encajas?", path: "/test-palos" },
    ],
  },
  { title: "FAQs", path: "/faq" },
  { title: "Donaciones", path: "/donaciones" },
  { title: "Contacto", path: "/contacto" },
  {
    title: "Cifrados",
    subItems: [
      { label: "A1Z26", path: "/cifrados/a1z26" },
      { label: "Binario", path: "/cifrados/binario" },
      { label: "César/ROT", path: "/cifrados/cesar" },
      { label: "Hexadecimal", path: "/cifrados/hexadecimal" },
      { label: "Morse", path: "/cifrados/morse" },
      { label: "Octal", path: "/cifrados/octal" },
      { label: "Vigenère", path: "/cifrados/vigenere" },
    ],
  },
];
